import { FC, Fragment, useState } from 'react';

import AutTable from '../../../blocks/aut-grid-table';
import EditVIReportDataItemForm from '../../../forms/visual-inspection/EditVIReportDataItemForm';
import VIReportDataItemForm from '../../../forms/visual-inspection/VIReportDataItemForm';

import { getVITableColumns } from '../../../../utils/data';
import { VIReportItem } from '../../../../utils/models';

interface VIReportItemsProps {
	reportItems: VIReportItem[];
	onDataChange: (items: VIReportItem[]) => void;
}

const VIReportItems: FC<VIReportItemsProps> = (props) => {
	const [itemToEdit, setItemToEdit] = useState<VIReportItem | null>(null);

	const handleAddItem = (item: VIReportItem) => {
		const newReportItems = [...props.reportItems];
		newReportItems.push({ ...item, id: props.reportItems.length + 1 });

		props.onDataChange(newReportItems);
	};

	const handleDeleteItem = (item: VIReportItem): void => {
		const newAnomalyData = props.reportItems.filter((i) => i.id !== item.id);
		props.onDataChange(newAnomalyData);
	};

	const handleEditItem = (item: VIReportItem): void => {
		const index: number = props.reportItems.findIndex((r) => r.id === item.id);

		const newReportItems = [...props.reportItems];
		newReportItems[index] = { ...newReportItems[index], ...item };

		props.onDataChange(newReportItems);
		setItemToEdit(null);
	};

	const handleCancelEdit = (): void => {
		setItemToEdit(null);
	};

	return (
		<Fragment>
			{itemToEdit ? (
				<EditVIReportDataItemForm
					reportItem={itemToEdit}
					onEdit={handleEditItem}
					onCancelEdit={handleCancelEdit}
				/>
			) : (
				<VIReportDataItemForm onAdd={handleAddItem} />
			)}

			<div className="divider my-4"></div>

			<AutTable
				data={props.reportItems}
				tableColumns={getVITableColumns()}
				onDeleteItem={handleDeleteItem}
				onEditItem={(item: VIReportItem) => setItemToEdit(item)}
			/>
		</Fragment>
	);
};

export default VIReportItems;
